import { propertyValue } from './dood-block-config';
import { doodModalConfig } from './dood-modal-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ZEROSIXOFFEREDPRODUCTPICKERMODAL_LEGACY_FIELD_ORDER = [
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  zerosixOfferedProductPickerModalDescriptor: _generatedZerosixOfferedProductPickerModalDescriptor,
  zerosixOfferedProductPickerModalModalDefinition,
  zerosixOfferedProductPickerModalDashboardLayout,
  zerosixOfferedProductPickerModalConfig,
  zerosixOfferedProductPickerModalResolveConfig,
  zerosixOfferedProductPickerModalProperties,
} = doodModalConfig(
  {
    name: "Zerosix - Offered product picker modal",
    handle: "zerosix-offered-product-picker-modal",
    internal_name: "ZerosixOfferedProductPickerModal",
    componentType: 'ZerosixOfferedProductPickerModalComponent',
    category: 'modal',
    description: "Zerosix - Offered product picker modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "zerosix-offered-product-picker-modal",
    allowed_in: ["ModalBlock"],
    sharedFields: {}
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        "label": "Couleur de fond"
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["background_color"],
          },
        ],
      },
    ],
  })
);

export function zerosixOfferedProductPickerModalDescriptor(): IBlockDescriptor;
export function zerosixOfferedProductPickerModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function zerosixOfferedProductPickerModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedZerosixOfferedProductPickerModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedZerosixOfferedProductPickerModalDescriptor, zerosixOfferedProductPickerModalProperties, fieldOrder);
}

export {
  zerosixOfferedProductPickerModalModalDefinition,
  zerosixOfferedProductPickerModalDashboardLayout,
  zerosixOfferedProductPickerModalProperties,
  zerosixOfferedProductPickerModalConfig,
  zerosixOfferedProductPickerModalResolveConfig,
};

export type ZerosixOfferedProductPickerModalConfig = typeof zerosixOfferedProductPickerModalConfig;
